export default __webpack_public_path__ + "static/media/hht1_ep14_minisitcom_03.c2c792f2.png";